import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { Crosshair, Layers } from 'lucide-react';
import { MEXICO_CENTER, DEFAULT_ZOOM } from '@/utils/constants';
import { useMapStore } from '@/stores/mapStore';

export default function MapControls() {
  const map = useMap();
  const toggleHighways = useMapStore((s) => s.toggleHighways);
  const highwaysVisible = useMapStore((s) => s.highwaysVisible);

  // Listen for center-map events from route panel
  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      if (detail?.lat != null && detail?.lon != null) {
        map.setView([detail.lat, detail.lon], 14);
        if (detail.name) {
          L.popup()
            .setLatLng([detail.lat, detail.lon])
            .setContent(`<strong>${detail.name}</strong>`)
            .openOn(map);
        }
      }
    };
    window.addEventListener('center-map', handler);
    return () => window.removeEventListener('center-map', handler);
  }, [map]);

  // Listen for fit-route-bounds events to re-center on the full route
  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      const polyline: [number, number][] | undefined = detail?.polyline;
      if (polyline && polyline.length > 0) {
        const bounds = L.latLngBounds(
          polyline.map(([lat, lon]) => [lat, lon] as [number, number])
        );
        if (bounds.isValid()) {
          map.closePopup();
          map.fitBounds(bounds, { padding: [40, 40], maxZoom: 14 });
        }
      }
    };
    window.addEventListener('fit-route-bounds', handler);
    return () => window.removeEventListener('fit-route-bounds', handler);
  }, [map]);

  const handleCenter = () => {
    map.setView(MEXICO_CENTER, DEFAULT_ZOOM);
  };

  return (
    <div className="absolute bottom-6 right-4 z-[600] flex flex-col gap-2">
      <button
        onClick={handleCenter}
        className="w-9 h-9 bg-bg-secondary border border-border-strong rounded-lg text-text-muted hover:text-accent-blue hover:border-accent-blue flex items-center justify-center transition-all shadow-lg"
        title="Centrar en México"
      >
        <Crosshair size={16} />
      </button>
      <button
        onClick={toggleHighways}
        className={`w-9 h-9 bg-bg-secondary border rounded-lg flex items-center justify-center transition-all shadow-lg ${
          highwaysVisible
            ? 'border-accent-blue text-accent-blue'
            : 'border-border-strong text-text-muted hover:text-accent-blue hover:border-accent-blue'
        }`}
        title="Toggle carreteras"
      >
        <Layers size={16} />
      </button>
    </div>
  );
}
